import { Modal } from "antd"
import { useEffect, useState } from "react"
import { useTenantNavigation } from "../../hooks/useTenantNavigation.js"
import { showLoader } from "../../utils/showloader.js"
import { useTranslation } from 'react-i18next';


const SubmitMessage = (props) => {
    const { t } = useTranslation();
    const { state, message, spaceId, requestDetail={} } = props
    const [openMessageModal, setOpenMessageModal] = useState(false)
    const [countdown, setCountdown] = useState(5)
    const navigate = useTenantNavigation()

    useEffect(() => {
        if(state){
            setOpenMessageModal(true)
            setCountdown(5)
        }
    },[state])

    useEffect(() => {
        if(!openMessageModal) return
        if(countdown <= 0){
            closeMessageModal()
            return
        }
        const timer = setTimeout(() => {
            setCountdown((prev) => prev - 1)
        }, 1000)
        return () => clearTimeout(timer)
    }, [openMessageModal, countdown])

    const closeMessageModal = () => {
        setOpenMessageModal(false);
        showLoader(false, {lock: false})
        if(requestDetail?.status !== "draft") {
            navigate("/app/space/" + spaceId + "/documents")
        }
    }

    return (
        <Modal className="application-submit-modal" open={openMessageModal} footer={false} onOk={closeMessageModal} onCancel={closeMessageModal}>
            <div className="message-box">
                <img src="/assets/success-message.gif"  />
                <div className="submit-message">{message}</div>
                <div className="redirect-timer">{t('Redirecting in')} {countdown} second...</div>
            </div>
        </Modal>

    )
}

export default SubmitMessage